import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { Button, Input } from '@nextui-org/react';
import React from 'react';

import { ServerSchema } from '@common/types';
import { ModernModal } from '@portal/components/common/ModernModal.ui';
import { PasswordInput } from '@portal/components/common/PasswordInput.ui';
import { TypographyUI } from '@portal/components/common/Typography.ui';

interface UpdateSslPasswordModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  server: ServerSchema | null;
  username: string;
  password: string;
  onUsernameChange: (val: string) => void;
  onPasswordChange: (val: string) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

export const UpdateSslPasswordModal: React.FC<UpdateSslPasswordModalProps> = ({
  isOpen,
  onOpenChange,
  server,
  username,
  password,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
  isLoading,
}) => {
  const icon = <ShieldCheckIcon className='h-4 w-4' />;
  const subtitle = server ? `${server.name}@${server.host}` : 'Update SSL credentials for server';

  const footer = (
    <>
      <Button color='danger' variant='light' onPress={onOpenChange} disabled={isLoading}>
        Cancel
      </Button>
      <Button color='primary' onPress={onSubmit} isLoading={isLoading} isDisabled={!password.trim()}>
        Update Password
      </Button>
    </>
  );

  return (
    <ModernModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title='Update SSL Password'
      subtitle={subtitle}
      icon={icon}
      size='lg'
      footer={footer}
    >
      <div className='flex flex-col gap-4'>
        <div>
          <TypographyUI className='text-sm text-gray-600 mb-2'>Server: {server?.name}</TypographyUI>
          <TypographyUI className='text-sm text-gray-600'>Host: {server?.host}</TypographyUI>
        </div>
        <Input label='SSL Username' value={username} isDisabled />
        <PasswordInput
          label='SSL Password'
          placeholder='Enter SSL password'
          value={password}
          onValueChange={onPasswordChange}
          isRequired
        />
      </div>
    </ModernModal>
  );
};
